import React from 'react';

import {
  useUserInvitationsState,
  useUserInvitationsActions
} from './UserInvitationsContext';

import {
  generateAndSendOpenUserInvitation,
} from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormRow from '../../Shared/UI/FormRow/components/FormRow';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';

const NewOpenUserInvitationsForm = () => {
  const userInvitationsState = useUserInvitationsState();
  const { onResponse, onError, updateFirstName, updateLastName, updateEmail } = useUserInvitationsActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    generateAndSendOpenUserInvitation({
      onResponse,
      onError,
      body: {
        newOpenUserInvitation: userInvitationsState?.newOpenUserInvitation,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormRow>
        <Field label="First Name" id="firstName">
          <Input
            type="text"
            value={userInvitationsState?.newOpenUserInvitation?.firstName}
            onChange={(e) => updateFirstName(e.target.value)}
          />
        </Field>

        <Field label="Last Name" id="lastName">
          <Input
            type="text"
            value={userInvitationsState?.newOpenUserInvitation?.lastName}
            onChange={(e) => updateLastName(e.target.value)}
          />
        </Field>
      </FormRow>

      <Field label="Email" id="email">
        <Input
          type="email"
          value={userInvitationsState?.newOpenUserInvitation?.email}
          onChange={(e) => updateEmail(e.target.value)}
        />
      </Field>

      <Button type="submit">
        Generate and send invitation
      </Button>
    </Form>
  );
};

export default NewOpenUserInvitationsForm;
